<template>
  <b-card no-body class="mb-2 mt-4  w-100 ">
            <slot></slot>
            <b-card-header v-on:click="changeAcording"  header-tag="header" class=" w-100 h-100 p-0" role="tab">
              <div  v-b-toggle="id" variant="info" class="head-mes">
                <div class="title-left pl-3">
                  <div class="title-colapse">{{UpperCase(title)}}</div>
                </div>
                <div class="componente">
                <i v-if="!changeAngel" class="fas fa-angle-down arrow-angel"></i>
                <i v-if="changeAngel" class="fas fa-angle-up arrow-angel"></i>
              </div>
              </div>
            </b-card-header>
            <b-collapse :id="id" :accordion="id" role="tabpanel" ref="testeacor">
              <b-card-body>
                <div  class="img-flex">
                  <div   v-for="(data, index) in dataImg" v-bind:key="index" :class="{'img-body':true}">
                    <div  v-on:click="$emit('imageDetails', data.arquivo, data.extensaos === null ?null : data.descricao.includes('.pdf') ? true : data.extensaos == 'mp4' ? null : false)"  class="h-100 img-flex-dir">
                    <i v-if="data.descricao.includes('.pdf')" style="font-size: 70px" class="fas fa-file-pdf icone"></i>
                    <i v-else-if="data.extensaos == 'mp4'" style="font-size: 70px" class="fas fa-video icone"></i>
                    <img v-else class="mb-2 img-body-body" :src="'data:image/jpeg;base64,' + data.arquivo">
                    <div class="img-footer">
                      <div  class="img-title">{{data.descricao == null ? 'N/D' : data.descricao}}</div>
                    </div>
                    </div>
                    <div class="edit-img" v-on:click="$emit('removeImg',data.arquivoId)">
                      <i class="fas fa-times"></i>
                    </div>
                  </div>
                  <slot  v-if="flAdd == true" name="newPick"></slot>
                </div>
                <!-- <div v-else class="img-flex">
                    <div   v-for="data in dataImg" v-bind:key="data.id" class="img-body-pdf">
                      <i style="font-size: 70px" class="fas fa-file-pdf"></i>
                      <div  class="img-title" v-on:click="$emit('imageDetails', data.arquivo.arquivo, true)">{{data.arquivo.descricao == null ? 'N/D' : data.arquivo.descricao}}</div>
                      <div class="img-footer">
                      </div>
                      <div class="edit-img" v-on:click="$emit('removeImg',data.id)">
                        <i class="fas fa-times"></i>
                      </div>
                    </div>
                  <slot  v-if="flAdd == true" name="newPick"></slot>
                </div> -->
              </b-card-body>
            </b-collapse>
          </b-card>
</template>

<script>
export default {
  name: 'CollapseImageDocumets',
  props: ['title', 'id', 'dataImg', 'flAdd', 'flDisable'],
  data () {
    return {
      changeAngel: false
    }
  },
  methods: {
    changeAcording () {
      this.changeAngel = !this.changeAngel
    },
    UpperCase (value) {
      let string = value
      let stringMaiuscula = string.toUpperCase()
      return stringMaiuscula
    }
  }

}
</script>

<style scoped>
.edit-img{
  height: 34px;
  top: 0px;
  z-index: 5;
  right: 0px;
  width: 40px;
  color: white;
  background-color: red;
  border-radius: 0px 8px 0px 15px;
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
}
.img-title {
  white-space: nowrap;
  text-overflow: ellipsis;
  width: 75%;
  text-align: center;
  overflow: hidden;
}
.img-body-body{
  position: relative;
  height: 100%;
  width: 100%;
  object-fit: cover;
  border-radius: 8px;
  z-index: 0;
}
.img-body{
  width: 270px;
  height: 185px;
  border-radius: 10px;
  position: relative;
  transition: 400ms;
  margin-bottom: 15px;
  cursor: pointer;
  margin-left: 2%;

}
.img-flex-dir{
    display: flex;
    justify-content: center;
    align-items: center;
}
.img-body-body{
  position: relative;
  height: 100%;
  width: 100%;
  object-fit: cover;
  border-radius: 8px;
  z-index: 0;
}
.img-footer{
  position: absolute;
  width: 100%;
  height: 30px;
  color: white;
  background: rgba(0, 0, 0, 0.644);
  bottom: 0px;
  border-radius: 0px 0px 10px 10px;
  display: flex;
  justify-content: center;
  align-content: center;
}
.img-flex{
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
}
.head-mes{
    display: flex;
    height: 40px;
    background-color: rgb(241, 241, 241);
    align-items: center;
    justify-content: space-between;
}
.title-left{
  display: flex;
  width: 100%;
  height: 100%;
  align-items: center;
}
.title-colapse{
  font-size: 16px;
  font-weight: bold;
  padding-left: 18px;
}
.img-flex{
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
}
.arrow-angel{
  font-size: 30px;
  color: #156b04;
  padding-right: 20px;
  padding-bottom: 10px;
}
.componente{
  font-size: 18px;
  color: black;
  padding-top: 9px;
  padding-left: 15px;
}

@media  (max-width: 1280px) {

}

</style>



// WEBPACK FOOTER //
// src/views/private/realestate/ocurrence/components/documentoccourences/components/collapseimagedocumets.vue